import React, { useEffect } from 'react';
import useNewCareerPositionContext from 'contexts/career-position.context';
import { Textarea } from '@cokitchen/cokitchen-components';

const CreateJobDescription = () => {
  const { createJobPositionForm, setCreateJobPositionForm, setDisabled } =
    useNewCareerPositionContext();

  const validateList = (input: string) => {
    const listData = input
      .split(/[\n,]+/)
      .map((name) => name.trim())
      .filter((name) => name.length > 0);

    return listData.length > 0 ? listData.every((name) => name.startsWith('-')) : false;
  };
  useEffect(() => {
    const disabled = ![
      createJobPositionForm.roleSummary,
      validateList(createJobPositionForm.responsibilities),
      validateList(createJobPositionForm.qualifications)
    ].every(Boolean);

    setDisabled(disabled);
  }, [createJobPositionForm]);
  return (
    <div className='space-y-4'>
      <Textarea
        className='w-full mt-1'
        label='Role summary'
        value={createJobPositionForm.roleSummary}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, roleSummary: e.target.value })
        }
        placeholder='Enter job role summary'
      />
      <Textarea
        className='w-full mt-1'
        label='Responsibilies'
        value={createJobPositionForm.responsibilities}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, responsibilities: e.target.value })
        }
        placeholder='Enter responsibilies (bullet points i.e "-")'
      />
      <Textarea
        className='w-full mt-1'
        label='Qualifications'
        value={createJobPositionForm.qualifications}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, qualifications: e.target.value })
        }
        placeholder='Enter qualifications (bullet points i.e "-")'
      />
    </div>
  );
};

export default CreateJobDescription;
